// extracted by mini-css-extract-plugin
module.exports = {"ofWarningIcon":"WarningIcon_ofWarningIcon__VdqYb","defaultColor":"WarningIcon_defaultColor__Edzbc"};